// ============================================================
// FILE: JobRow.js
// LOCATION: C:\gardenmarket\web\src\pages\buyer\JobRow.js
// ============================================================
// PURPOSE:
//   One row in the My Jobs list. Uses buyerStatusLabels from
//   theme.js so 'matched' shows as "Open — gardeners notified"
//   rather than a separate confusing "Matched" status.
// ============================================================

import { statusColours, buyerStatusLabels, radius, colors } from '../../theme/theme';

export default function JobRow({ job, isSelected, onClick }) {
    const showsReviewColumn = ['completed', 'reviewed'].includes(job.status_code);
    const colours = statusColours[job.status_code] || statusColours.draft;
    const label   = buyerStatusLabels[job.status_code] || job.status_label;

    return (
        <tr onClick={onClick} style={{
            cursor: 'pointer',
            backgroundColor: isSelected ? '#E8F5EE' : 'transparent',
            borderLeft: isSelected ? '3px solid #2d6a4f' : '3px solid transparent',
            borderBottom: `1px solid ${colors.border}`,
        }}>
            <td style={{ width:'60px', padding:'12px 8px 12px 14px', verticalAlign:'top', fontSize:'0.78rem', color:colors.textFaint, whiteSpace:'nowrap' }}>
                {job.posted_at ? new Date(job.posted_at).toLocaleDateString('en-AU', { day:'numeric', month:'short' }) : '—'}
            </td>
            <td style={{ padding:'12px 8px', verticalAlign:'top', overflow:'hidden', maxWidth:'0', width:'100%' }}>
                <div style={{ fontSize:'0.93rem', fontWeight:700, color:colors.text, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>
                    {job.title}
                </div>
                <div style={{ fontSize:'0.8rem', color:colors.textFaint, marginTop:'2px' }}>
                    {job.accepted_gardener_name
                        ? job.accepted_gardener_name
                        : job.quote_count > 0
                            ? `${job.quote_count} quote${job.quote_count > 1 ? 's' : ''}`
                            : job.matched_count > 0
                                ? `${job.matched_count} notified`
                                : '—'}
                </div>
            </td>
            <td style={{ width:'110px', padding:'12px 14px 12px 8px', verticalAlign:'top', textAlign:'right' }}>
                <span style={{
                    backgroundColor: colours.bg,
                    color:           colours.text,
                    fontWeight:      'bold',
                    fontSize:        '0.7rem',
                    padding:         '3px 9px',
                    borderRadius:    radius.pill,
                    whiteSpace:      'nowrap',
                    display:         'inline-block',
                }}>
                    {label}
                </span>
                {showsReviewColumn && (
                    <div style={{fontSize:'0.68rem', marginTop:'4px', color: job.status_code === 'reviewed' ? '#2d6a4f' : '#bbb'}}>
                        {job.status_code === 'reviewed' ? '✓ Reviewed' : 'Awaiting review'}
                    </div>
                )}
            </td>
        </tr>
    );
}
